// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Oxos","disabled":"FileBtn_disabled__3uPAc","warn":"FileBtn_warn__1mD6k","fade":"FileBtn_fade__af9H5"};